import React, { useEffect } from 'react';
import {connect} from "react-redux";
import {Card, CardBody, CardTitle } from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';

// components
import ChefForm from "./_form";
import ChefFilters from "./_filters";
import {ActiveFormatter} from "../../../components/tables/activeFormater";
import TranslateButton from "../../../components/buttons/TranslateButton";
import {ConfirmDelete} from "../../../components/confirmAlert/ConfirmDelete";
import { GenericTableButton,} from "../../../components/buttons/buttonsActions";
import {ModalFormContainer} from "../../../components/confirmAlert/ModalFormContainer";

// labels
import { LIST, NO_DATA_FOUND } from "../../../components/i18n/i18n";
import {TT_DELETE, TT_EDIT,} from "../../../components/i18n/toolTips";

// service
import {chefService} from "../../../jwt/_services/ayb/chefService";

// actions
import { genericActions } from "../../../redux/actions/generics/GenericActions";
import { setForm, setItem } from "../../../redux/actions/generalActions/formActions";
import { setViewMode, setParent  } from "../../../redux/actions/generalActions/mainActions";
import { setFilter, setTableParams } from "../../../redux/actions/generalActions/listActions";


const ChefList = props => {
    const { app, udn, category } = props.mainProps
    const { pageSize, pageIndex, totalSize, listDomainObjects, filter } = props.listProps

    // asignar los valores por default del filtro
    useEffect( () => {
        if( !app.id || !udn.id || !category || filter)
            return

        const _filter = {
            onlyRegistered : true,
            fbDataBase : { id : app?.fbDataBase?.id },
            item : {
                udn : { id: udn.id },
                categoryCodes : category
            }
        };

        props.setFilter(_filter);
    }, [ app, udn, category ]);

    // realizar búsqueda cuando cambie el filtro
    useEffect(() => {
        if(!filter)
            return

        genericActions.search(chefService, pageIndex, pageSize, filter)
    }, [pageIndex, pageSize, filter ]);

    const handleTableChange = (type, tableChangeParams) => {
        let currentIndex = (tableChangeParams.page - 1) * tableChangeParams.sizePerPage;
        props.setTableParams( tableChangeParams.sizePerPage, currentIndex );
    };

    const confirmDelete = (data) => ConfirmDelete({
        remove : genericActions.remove ,
        data : data,
        fbDataBaseId : app?.fbDataBase?.id,
        service: chefService } );

    const editItem = (data) => {
        props.setForm(true, false, false);
        props.setItem(data);
        ModalFormContainer(ChefForm, { data, Form: ChefForm })
    }

    const activeFormatter = (cell) => <ActiveFormatter active={cell}/>

    const actionsFormatter = (cell, row) => <>
        <GenericTableButton toolTip={TT_EDIT} icon={'fa-pen'} permission={'edit'} onClick={() => editItem(row)}/>
        <TranslateButton item={row} service={chefService} />
        <GenericTableButton toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={() => confirmDelete(row)}/>
    </>


    const columns = [{
        dataField: 'id',
        headerStyle: {width: '0px'},
        text: 'ID',
        hidden: true
    }, {
        dataField: 'uid',
        text: 'uid',
        headerStyle: {width: '200px'},
    }, {
        dataField: 'name',
        text: 'Nombre'
    }, {
        dataField: 'status',
        text: "Activo",
        headerAlign: 'center',
        align: 'center',
        headerStyle: {width: '80px'},
        formatter: activeFormatter
    }, {
        dataField: 'Actions',
        isDummyField: true,
        text: 'Acción',
        headerAlign: 'center',
        align: 'center',
        headerStyle: {width: '200px'},
        formatter: actionsFormatter
    }];

    return (
        <div>
            <Card>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <i className="far fa-list-alt mr-2"> </i>{LIST}
                </CardTitle>

                <ChefFilters />

                <CardBody className="">
                    <BootstrapTable
                        striped hover
                        tableHeaderClass='mb-0'
                        remote
                        keyField="id"
                        data={listDomainObjects || []}
                        columns={columns}
                        noDataIndication={NO_DATA_FOUND}
                        pagination={paginationFactory({pageIndex, pageSize, totalSize})}
                        onTableChange={handleTableChange}
                    />
                </CardBody>
            </Card>
        </div>
    )
}

const mapStateToProps = state => ({
    mainProps : state.mainProps,
    listProps : state.listProps,
})

const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setViewMode,
    setForm,
    setItem,
    setParent,
})
export default connect(mapStateToProps, mapActionsToProps)(ChefList)